<template>
  <div class="page-exbition-detail">
    <div class="qrcode" ref="qrCode"></div>

    <div class="detail-box">
      <div class="left">
        <h1 class="two-ell">{{ detail.activityName }}</h1>

        <div class="flex-box">
          <div>
            <div class="box">
              <span class="label">活动时间：</span>
              <span class="val">{{ detail.activityTime }}</span>
            </div>

            <div class="box">
              <span class="label">活动地点：</span>
              <span class="val">{{ detail.activityAddr }}</span>
            </div>

            <div class="box">
              <span class="label">年龄范围：</span>
              <span class="val">{{ detail.ageStr }}</span>
            </div>

            <div class="box">
              <span class="label">活动类型：</span>
              <span class="val">{{ detail.typeName }}</span>
            </div>
          </div>
<!-- 
          <div class="img-box" v-if="detail.activityStatus == 1">
            <img class="img-qrCode" ref="imgQrCode" :src="detail.qrCode" alt="">
            <span class="btn m-font-5" @mouseenter="mouseenter" @mouseleave="mouseleave">立即报名</span>
          </div> -->
        </div>

      </div>

      <div class="right">
        <img v-lazy="detail.pictureUrl" alt="">
      </div>
    </div>

    <div class="detail-content">
      <div class="mb-40">
        <h2>活动详情</h2>
        <!-- <p v-html="detail.description"></p> -->
        <div class="g-detail-html" v-html="detail.description"></div>
      </div>

      <div>
        <h2>活动要求</h2>
        <p>{{ detail.demand }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"
export default {

  data() {
    return {
      detailId: this.$route.query.id,
      detail: {}
    };
  },

  mounted() {
    this.getDetailData()
  },

  methods: {
    createQrcode() {
      new QRCode(this.$refs.qrCode, {
        text: 'https://wxxcx.lnmuseum.com.cn/socialActivitySign?id=' + this.detail.id,
        width: 72,
        height: 72,
        colorDark: "#000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })

      html2canvas(this.$refs.qrCode, {
        backgroundColor: null,
        width: 72,
        height: 72
      }).then(canvas => {
        var imgData = canvas.toDataURL('image/jpeg')  //这里转为图片方式 `[base64转图片并显示](https://blog.csdn.net/weixin_45527702/article/details/117324946)`
        this.$set(this.detail, 'qrCode', imgData);
      })
    },
    getDetailData() {
      this.$http
        .get('../singleMuseum/api/bsActivity/getActivityDetail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detail = res.result
            this.createQrcode()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    mouseenter() {
      this.$refs['imgQrCode'].style.opacity = '1'

    },
    mouseleave() {
      this.$refs['imgQrCode'].style.opacity = '0'
    },

  },
};
</script>

<style lang="scss" scoped>
  .qrcode {
    position: absolute;
    top: -80px;
    left: -80px;
    z-index: -99;
  }
.detail-box {
  display: flex;
  background: #f6f6f6;
  padding: 40px 160px 70px 162px;
  
  .left {
    flex: 1;
    padding-top: 111px;
    margin-right: 80px;
    h1 {
      font-size: 32px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 66px;
    }
    .box {
      margin-bottom: 25px;
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        font-size: 22px;
        font-weight: 400;
        color: rgba($color: #000000, $alpha: 0.7);
      }

      .val {
        font-size: 22px;
        font-weight: 400;
        color: #000000;
      }
    }

    .flex-box {
      align-items: flex-end;
      justify-content: space-between;
      .img-box {
        flex-shrink: 0;
        position: relative;
        margin-left: 40px;
        .img-qrCode {
          opacity: 0;
          position: absolute;
          top: -100%;
          right: 3px;
          transition: all 0.6s;
        }

        .btn {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          // font-size: 16px;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: #ae8148;
          color: #fff;
          &:hover {
            background: #be9a6d;
          }
        }
      }
    }
  }

  .right {
    flex-shrink: 0;
    flex-basis: 916px;
    height: 516px;
    img {
      width: 100%;
      height: 100%;
      object-fit:contain;
    }
  }
}

.detail-content {
  padding: 73px 724px 173px 163px;
  h2 {
    font-size: 22px;
    font-weight: 400;
    color: #000000;
    margin-bottom: 20px;
  }

  // p {
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: rgba($color: #000000, $alpha: 0.9);
  //   line-height: 32px;
  // }
}
</style>